import React from "react";
import PublicFeatureLandingPage from "../../../../platform/components/common/PublicFeatureLandingPage";
import { buildCareJobsFindShareMessage } from "../../../../platform/util/publicShareMessages";
import CareJobAlertSignupCard from "../components/CareJobAlertSignupCard";

const SHARE_PATH = "/care/jobs/find";

export default function JobSearchLandingPage(): JSX.Element {
  return (
    <PublicFeatureLandingPage
      path={SHARE_PATH}
      seoTitle="Find Caregiving Jobs | Plany365"
      seoDescription="Browse open caregiving and care staff jobs on Plany365."
      eyebrow="Job Search"
      title="Find a caregiving job"
      description="Use this page to find care-related jobs, sign up for free alerts, and apply to open roles on Plany365."
      highlights={[
        "Browse active caregiving jobs in one place.",
        "Search and apply to open jobs for free.",
        "Sign up once for free care job alerts.",
        "Use one simple share link for WhatsApp, Facebook, text, and social groups.",
      ]}
      actions={[
        {
          label: "Browse Open Jobs",
          href: "/care/jobs",
          variant: "contained",
        },
        {
          label: "My Jobs & Profile",
          href: "/care/myjobs",
          variant: "outlined",
        },
        {
          label: "See Pricing",
          href: "/care/jobs/pricing",
          variant: "outlined",
        },
      ]}
      buildShareMessage={buildCareJobsFindShareMessage}
      shareDescription="Use this message when you want to share caregiving job openings with job seekers."
    >
      <CareJobAlertSignupCard />
    </PublicFeatureLandingPage>
  );
}
